
    <fieldmagic-primary-button
      icon="exclamation-circle"
      [disabled]="fetching$ | async"
      [label]="(details$ | async) | data_get: 'label'"
      [color]="(details$ | async) | data_get: 'color'"
      tooltip="Click to view defects"
      (click)="onView()"
    >
    </fieldmagic-primary-button>
  